import React, { useState, useCallback, useEffect } from "react";
import DropZone from "components/dropzone";
import ImageCropper from "components/image-cropper";
import { connect } from "formik";

const ImageUpload = ({ name, closeModal, formik, onSubmit = () => {} }) => {
  const [uncroppedImage, setUncroppedImage] = useState(null);
  const [imageType, setImageType] = useState(null);

  useEffect(() => {
    if (!formik.values[name]) {
      setUncroppedImage(null);
    } else {
      setUncroppedImage(formik.values[name]?.fileURL);
      setImageType(formik.values[name]?.file?.type);
    }
  }, [formik, name]);

  const cropHandler = (image) => {
    setUncroppedImage(null);
    formik.setFieldValue(name, image);
  };

  const closeHandler = useCallback(() => {
    formik.setFieldValue(name, null);
    setUncroppedImage(null);
  }, [formik, name]);

  const Cropper = () => (
    <ImageCropper
      open={!!uncroppedImage}
      closeHandler={closeHandler}
      cropHandler={cropHandler}
      imageB64={uncroppedImage}
      imageType={imageType}
    />
  );

  return (
    <>
      <DropZone
        name={name}
        config={{
          accept: "image/*",
          maxSize: 5000000,
          errMessage:
            'Please be sure to upload a <span style="font-style: italic;">single</span> JPG, JPEG, or PNG image no larger than <span style="font-style: italic;">5MB</span>.',
        }}
        closeModal={closeModal}
        imageCropper={uncroppedImage ? <Cropper /> : null}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default connect(ImageUpload);
